import {assetIsPresent} from '@netx/core-asset-next/utils/assetIsPresent';
import {
	allows,
	PermissionMatrixName,
} from '@netx/core-permissions/utils/allows';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {type IAsset} from '../schema';

export const canCreatePdfFromAsset = (asset?: IAsset) =>
	asset != null &&
	currentUserMeetsUserLevel(UserLevel.CONSUMER) &&
	assetIsPresent(asset) &&
	allows(asset.permissionMatrix, PermissionMatrixName.DOWNLOAD);

export default canCreatePdfFromAsset;
